import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Avatar from '@material-ui/core/Avatar';
import AccountCircle from '@material-ui/icons/AccountCircle';
import ShoppingCart from '@material-ui/icons/ShoppingCart';
import { Link } from 'react-router-dom';

function renderAvatarOrAccountCircle(user) {
  if (user) {
    if (user.userInfo) {
      if (user.userInfo.profile_img) {
        return (
          <Avatar src={user.userInfo.profile_img} />
        );
      }
    }
  }
  return <AccountCircle />;
}

function DesktopNav(props) {
  const {
    classes,
    handleAboutMenu,
    handleClassesMenu,
    handleTrainingsMenu,
    // handleEventsMenu,
    handleShopMenu,
    userMenuOpen,
    handleUserMenu,
    user,
  } = props;

  return (
    <div className={classes.sectionDesktop}>
      <Button color="inherit" onClick={handleAboutMenu}>About</Button>
      <Button target="_blank" rel="noopener noreferrer" color="inherit" href="https://niaondemand.com">On Demand</Button>
      <Button color="inherit" onClick={handleClassesMenu}>Classes</Button>
      <Button color="inherit" onClick={handleTrainingsMenu}>Trainings</Button>
      {/* <Button color="inherit" onClick={handleEventsMenu}>Events</Button> */}
      <Button color="inherit" onClick={handleShopMenu}>Shop</Button>
      {/* <Button color="inherit" href="/membership">Teach</Button>* /}
      {/* <Button color="inherit" href="/join">Join</Button> */}
      <Button color="inherit" href="/teach">Teach</Button>
      {user && (
        <React.Fragment>
          <IconButton
            aria-owns={userMenuOpen ? 'menu-appbar' : null}
            aria-haspopup="true"
            onClick={handleUserMenu}
            color="inherit"
          >
            {renderAvatarOrAccountCircle(user)}
          </IconButton>
          <IconButton
            component={Link}
            to="/shop/cart"
            color="inherit"
          >
            <ShoppingCart />
          </IconButton>
        </React.Fragment>
      )}
      {!user && (
        <React.Fragment>
          <Button color="inherit" href="/login">Login</Button>
        </React.Fragment>
      )}
    </div>
  );
}

DesktopNav.propTypes = {
  classes: PropTypes.object.isRequired,
  handleAboutMenu: PropTypes.func.isRequired,
  handleShopMenu: PropTypes.func.isRequired,
  handleTrainingsMenu: PropTypes.func.isRequired,
  // handleEventsMenu: PropTypes.func.isRequired,
  handleClassesMenu: PropTypes.func.isRequired,
  userMenuOpen: PropTypes.bool.isRequired,
  handleUserMenu: PropTypes.func.isRequired,
  user: PropTypes.object,
};

export default DesktopNav;
